
import { call, put } from 'redux-saga/effects';
import axios from 'axios';
import { ERROR_MESSAGE } from '../../redux/modules/message/message-actions';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';
import {
    didApiCallFailDueToUnauthorizedUser,
    didApiCallFailDueToVersionMismatch,
    getErrorMessage,
} from '../../constants/CommonUtil';
import { MISMATCH_IN_VERSION, SESSION_TIMEOUT } from '../../redux/modules/login/login-actions';
import {
    FETCH_PREVIOUS_PURCHASE_INVOICE_LINES_FAILURE,
    FETCH_PREVIOUS_PURCHASE_INVOICE_LINES_SUCCESS,
} from '../../redux/modules/previousPurchaseInvoiceLines/previousPurchaseInvoiceLines-actions';

export default function* previousPurchaseInvoiceLinesWorker(action) {
    try {
        const {
            api,
            page,
            size,
            searchConstruct,
        } = action;
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(axios.post, `${api}?page=${page}&size=${size}`, searchConstruct);
        yield put({
            type: FETCH_PREVIOUS_PURCHASE_INVOICE_LINES_SUCCESS,
            data: {
                ...(response.data || {}),
            },
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            const msg = 'Previous Purchase invoice lines fetch failed';
            yield put({ type: ERROR_MESSAGE, message: `${msg}: ${getErrorMessage(e)}` });
        }
        yield put({ type: FETCH_PREVIOUS_PURCHASE_INVOICE_LINES_FAILURE, data: action.payload });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}
